import { useMemo, useCallback } from "react";
import classnames from "classnames";
import DropdownSelect from "@/components/DropdownSelect";
import { useMatchMedia } from "@/hooks";
import dayjs from "@/lib/day";
import styles from "@/styles/DateTab.module.scss";

export default function DateTab({ selectedDay, onClick }) {
  const mobileSize = useMatchMedia(
    [{ query: "screen and (max-width: 520px)", value: true }],
    false
  );
  const days = useMemo(() => {
    const now = dayjs();
    const range = [...Array(8)].map((_, k) => k);
    return range.map((i) => {
      const day = now.add(i, "day");
      return {
        text: i == 0 ? "本日" : day.format("M/D(dd)"),
        value: day.format("YYYY-MM-DD"),
      };
    });
  }, []);

  const handleClick = useCallback((day) => {
    return () => {
      if (onClick) {
        onClick(day);
      }
    };
  }, []);

  const handleSelect = useCallback(({ value }) => {
    if (onClick) {
      onClick(value);
    }
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        {!mobileSize && (
          <>
            {days.map((day) => (
              <div
                key={day.value}
                className={classnames(styles.tab, {
                  [styles.active]: day.value === selectedDay,
                })}
                onClick={handleClick(day.value)}
              >
                {day.text}
              </div>
            ))}
          </>
        )}
        {mobileSize && (
          <DropdownSelect
            className={styles.dropdown}
            options={days}
            onSelect={handleSelect}
          />
        )}
      </div>
    </div>
  );
}
